<template>
    <div style="padding: 15px; padding-bottom:0; color:#000; margin-bottom: 50px;" :id="qid">
        <div class="row" :id="'diff-wrapper'+qid">

            <!-- Messages -->
            <div class="col-md-12 quiz-message-row"
                 v-bind:class="{'alert-success': validate(), 'alert-danger': !validate()}">
                <span class="pull-right" v-html="validationErrorMessage ? validationErrorMessage : 'This question is valid!'"></span>
            </div>

            <!-- Question Properties -->
            <div class="col-md-2 quiz-left-column question-row">
                <input type="hidden" :name="'questions['+idx+'][qid]'" :value="qid"/>
                <input type="hidden" :name="'questions['+idx+'][suggestedAnswerOid]'" :value="suggestedAnswerOid"/>
                <b>
                    {{getLevelName(level)}}<br/><br/>
                    {{camelCaseToWords(type)}}
                </b>
                <br/><br/>
                <div align="center" style="margin-bottom: 10px;" v-if="pictureUrl !== ''">
                    <a :href="pictureUrl" target="_blank" tabindex="-1">
                        <img :src="pictureUrl" style="max-height: 50px; max-width: 50px;"/>
                    </a>
                </div>
            </div>

            <!-- Question Text -->
            <div class="col-md-3 quiz-text-column question-row">
                <h4>Master</h4>
                <p dir="auto" style="padding-bottom: 5px; line-height: 2em;" v-html="XX_en"
                   :id="'original'+qid"></p>
                <p dir="auto" style="padding-bottom: 5px; line-height: 2em;" class="hide" v-html="localization"
                   :id="'changed'+qid"></p>
            </div>
            <div class="col-md-3 quiz-text-column question-row">
                <h4>Localization</h4>
                <div dir="auto" style="padding-bottom: 5px; line-height: 2em;" :class="'diff'+qid"></div>
            </div>

            <div class="col-md-4 quiz-text-column question-row">
                <h4>Translated Localization</h4>
                <input type="hidden" :name="'questions['+idx+'][text]['+locale+']'" :value="transLocalization"/>
                <textarea :title="locale"
                          rows="6"
                          dir="auto"
                          v-model="transLocalization"
                          onkeyup="preview(this.value)"
                          onfocus="preview(this.value);">
                </textarea>
            </div>
        </div>

        <!-- Options -->
        <quiz-translated-localization-option
                v-for="(option, oidx) in options"
                ref="options"
                :questionIdx="idx"
                :key="option.oid"
                :oid="option.oid"
                :qid="qid"
                :idx="oidx"
                :isSuggestedAnswer="suggestedAnswerOid === option.oid"
                :isCorrect="option.isCorrect"
                :XX_en="option.text.XX_en"
                :localization="option.text[localizationLocale]"
                :itransLocalization="option.text[locale]"
                :locale="locale"
        >
        </quiz-translated-localization-option>
    </div>
</template>


<script>
    require('../../../../vendor/jquery/plugins/diff_match_patch/javascript/diff_match_patch');
    require('../../../../vendor/jquery/plugins/preetyTextDiff/jquery.pretty-text-diff.min');

    export default {
        props: {
            'idx': Number,
            'qid': String,
            'type': String,
            'level': Number,
            'XX_en': String,
            'localization': String,
            'itransLocalization': String,
            'pictureUrl': String,
            'ioptions': Array,
            'locale': String,
            'localizationLocale': String,
            'countryName': String,
            'suggestedAnswerOid': String,
        },

        // the initial props are overwritten whenever the parent issues a re-rendering
        // (e.g. on adding/deleting questions), so we store them when the component
        // is loaded the first time, so we keep the user's changes.
        data: function() {
            return {
                transLocalization: this.itransLocalization,
                options: this.ioptions,
                updateTrigger: false,
                optionAddingOngoing: false,
            };
        },

        mounted: function() {
            this.updateTrigger = true;
            this.forceUpdate();

            $('#diff-wrapper' + this.qid).prettyTextDiff({
                originalContent: $('#original' + this.qid).html(),
                changedContent: $('#changed' + this.qid).html(),
                diffContainer: '.diff' + this.qid,
                debug: false,
            });
        },

        computed: {
            hasOptionWithLatexSyntax: function() {
                // can only do this when mounting is done - otherwise we don't have access to this.$refs;
                if (!this.updateTrigger) {
                    return false;
                }

                for (let index in this.$refs.options) {
                    let option = this.$refs.options[index];

                    if ((option.transLocalization.match(/\$/g) || []).length >= 2) {
                        return true;
                    }
                }

                return false;
            },

            hasEmptyOptions: function() {
                // can only do this when mounting is done - otherwise we don't have access to this.$refs;
                if (!this.updateTrigger) {
                    return 0;
                }

                for (let index in this.$refs.options) {
                    let option = this.$refs.options[index];
                    if (option.transLocalization.trim() === '') {
                        return true;
                    }
                }

                return false;
            },

            validationErrorMessage: function() {

                // can only do this when mounting is done - otherwise we don't have access to this.$refs;
                if (!this.updateTrigger) {
                    return 'Loading...';
                }

                if (this.localization.trim() === '') {
                    return 'You have to fill the question-localization!';
                }

                if (this.hasEmptyOptions) {
                    return 'You have to fill all option-localization!';
                }

                if (this.type === 'freeText' && this.hasOptionWithLatexSyntax) {
                    return 'An option has LaTeX syntax. Free-Text options cannot have more than 1 Dollar-sign.';
                }

                return null;
            },
        },

        methods: {
            getLevelName(levelNumber) {
                switch (levelNumber) {
                    case 1:
                        return 'Easy';
                    case 2:
                        return 'Medium';
                    case 3:
                        return 'Hard';
                    default:
                        return 'INVALID LEVEL: ' + levelNumber;
                }
            },

            forceUpdate: function() {
                this.updateTrigger = false;
                this.updateTrigger = true;
                this.validate();
                this.$forceUpdate();
                this.$emit('forceUpdate');
            },

            validate: function() {
                let messageElem = $('#' + this.qid + '_message');

                if (this.validationErrorMessage != null) {
                    messageElem.removeClass('text-success');
                    messageElem.addClass('text-danger');
                    messageElem.innerHTML = this.validationErrorMessage;
                    return false;
                } else {
                    messageElem.removeClass('text-danger');
                    messageElem.addClass('text-success');
                    messageElem.innerHTML = 'This question seems valid!';
                    return true;
                }
            },

            camelCaseToWords: (camelCased) => {
                return camelCased.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + camelCased.replace(/([A-Z])/g, ' $1').slice(1);
            },
        },
    };
</script>
